import React from "react";
import { MenaVstupy, PercentaVstupy, IntegerVstupy } from "../vstupneKomponenty";

const InvestovanieVstupKarta = React.forwardRef(function InvestovanieVstupKarta({
  invOpen,
  invProfil,
  setInvProfil,
  setInvZhodnotenie,
  invVystupPS,
  setInvVystupPS,
  invJednoraz,
  setInvJednoraz,
  invMesacne,
  setInvMesacne,
  invZhodnotenie,
  invHorizont,
  setInvHorizont,
  invHorizontTouched,
}, ref) {
  if (!invOpen) return null;

  return (
    <div ref={ref} className="card-section card-section--inv-vstup">
      <div className="prepay-head">
                        <h2>Sporenie / Investovanie</h2>
                      </div>
          
                      <div className="inv-mode-row">
                        <span className="inv-mode-label"><strong>Investičný profil:</strong></span>
          
                        <div className="inv-toggles">
                          <div className="pp-stepper">
                            <button
                              type="button"
                              className={`pp-step ${invProfil === 'konzervativny' ? 'is-active' : ''}`}
                              onClick={() => {
                                setInvProfil('konzervativny');
                                setInvZhodnotenie(4);
                              }}
                            >
                              Konzervatívny
                            </button>
          
                            <button
                              type="button"
                              className={`pp-step ${invProfil === 'vyvazeny' ? 'is-active' : ''}`}
                              onClick={() => {
                                setInvProfil('vyvazeny');
                                setInvZhodnotenie(6);
                              }}
                            >
                              Vyvážený
                            </button>
          
                            <button
                              type="button"
                              className={`pp-step ${invProfil === 'dynamicky' ? 'is-active' : ''}`}
                              onClick={() => {
                                setInvProfil('dynamicky');
                                setInvZhodnotenie(9);
                              }}
                            >
                              Dynamický
                            </button>
                          </div>
                        </div>
          
                        <div className="toggle-group inv-ps-toggle">
                        <label className="chk">
                          <strong>Predčasné splatenie:</strong>
                          <input
                            type="checkbox"
                            checked={invVystupPS}
                            onChange={(e) => setInvVystupPS(e.target.checked)}
                          />
                        </label>
                        </div>
          
                      </div>
          
                        <div className="form-group form-group--cols4">
                          <div className="form form--m">
                            <MenaVstupy
                              value={invJednoraz}
                              onChange={(v) => setInvJednoraz(Math.max(0, v))}
                              maxDigits={7}
                              suffix="€"
                              placeholder="0"
                            />
                            <label className="form_label">Jednorazovo</label>
                          </div>
          
                          <div className="form form--m">
                            <MenaVstupy
                              value={invMesacne}
                              onChange={(v) => setInvMesacne(Math.max(0, v))}
                              maxDigits={7}
                              suffix="€"
                              placeholder="0"
                            />
                            <label className="form_label">Mesačne</label>
                          </div>
          
                          <div className="form form--m">
                            <PercentaVstupy
                              value={invZhodnotenie}
                              onChange={(v) => setInvZhodnotenie(Math.max(0, v))}
                              maxInt={2}
                              placeholder=" "
                            />
                            <label className="form_label">Zhodnotenie (p.a.) </label>
                          </div>
          
                          <div className="form form--m">
                            <IntegerVstupy
                              value={invHorizont}
                              onChange={(v) => { invHorizontTouched.current = true; setInvHorizont(Math.min(99, Math.max(0, v))); }}
                              maxDigits={2}
                              min={0}
                              max={99}
                              placeholder=" "
                            />
                            <label className="form_label">Horizont (r)</label>
                          </div>
          
                        </div>
                         
                            <div className={`inv-hint pp-hint error ${ (invJednoraz === 0 && invMesacne === 0) ? '' : 'is-placeholder'}`}>
                              Zadaj aspoň jednu vstupnú hodnotu
                            </div>
    </div>
  );
});

export default InvestovanieVstupKarta;